import experiments from '../../common/constants/experiments'

export default {
  name: 'VideoHive',
  abbreviation: 'VH',
  domain: 'videohive.net',
  google_analytics_id: 'UA-11834194-8',
  google_remarketing_label: 'NrSdCMX_uQMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. photo slideshow',
  assets_domains: {
    item_thumbnail: 'thumb-vh.s3.envato.com',
    item_image: 'image-vh.s3.envato.com'
  },
  features: {
    /**
     * @description
     * @author Geoff Evason
     * @expires
     */
    'collapse-tags-unless-bottom-category': true,
    /**
     * @description Decide whether to display v0 or v1 item cards in search results page.
     * @author Pawel Galazka
     * @expires When all markets will use v1 item card
     */
    'v0-search-results': true,
    /**
     * @description Decide whether to display v0 or v1 item cards in featured/popular items page.
     * @author Pawel Galazka
     * @expires When all markets will use v1 item card
     */
    'v0-featured-page': true,
    /**
     * @description Decide whether to show new item card in search page
     * @author Chris & Javed
     * @expires When VH phase 1 has ended
     */
    'videoHiveNewItemCard:enrolment': true,
    videoHiveNewItemCard: false,
    /**
     * @description Decide whether to show or hide layout toggle
     * @author Chris
     * @expires When VH phase 1 has ended
     */
    removeLayoutSwitcher: false,
    /**
     * @description Show a spinner between the time the server page loads, and the time the client has finished.  This should be turned on for most A/B tests to avoid flicker/changes on client load.
     * @author Conversion Team
     * @expires Never
     */
    'experiments:loading-cover': true
  },
  ui: {
    featured_hero_item_viewtype: 'grid'
  },
  experiments_to_features: {
    [experiments.videoHiveNewItemCard]: {
      0: {
        videoHiveNewItemCard: false,
        'v0-search-results': true,
        removeLayoutSwitcher: false
      },
      1: {
        videoHiveNewItemCard: false,
        'v0-search-results': true,
        removeLayoutSwitcher: false
      },
      2: {
        videoHiveNewItemCard: true,
        'v0-search-results': false,
        removeLayoutSwitcher: true
      },
      3: {
        videoHiveNewItemCard: true,
        'v0-search-results': false,
        removeLayoutSwitcher: true
      }
    }
  }
}
